module.exports = __webpack_public_path__ + "img/icon_paperclip.b7b183b4.svg";